document.addEventListener('DOMContentLoaded', () => {
    const productsOnPage = document.querySelector('.grid.product-grid');
    const loadMoreBtn = document.querySelector('.load-more-btn');
    const loadPrevBtn = document.querySelector('.load-prev-btn');
    const currentOffset = document.querySelector('#paginate-current-offset').innerText;
    let nextUrl = productsOnPage.dataset.nextUrl;
    let prevUrl = productsOnPage.dataset.prevUrl;

    if (!nextUrl) {
        loadMoreBtn.classList.add('hidden');
    }

    loadMoreBtn.addEventListener('click', async (e) => {
        await updateProducts(e, nextUrl, 'beforeend');
        if (!nextUrl) {
            loadMoreBtn.classList.add('hidden');
        }
    });

    loadPrevBtn.addEventListener('click', async (e) => {
        await updateProducts(e, prevUrl, 'afterbegin');
        if (!prevUrl || prevUrl.includes('page=1')) {
            loadPrevBtn.classList.add('hidden');
        }
    });

    async function updateProducts(event, url, position) {
        event.preventDefault();
        fetch(url)
            .then((response) => response.text())
            .then((response) => {
                const parser = new DOMParser();
                const nextPage = parser.parseFromString(response, 'text/html');
                const newProducts = nextPage.querySelector('.grid.product-grid');
                const newOffset = nextPage.querySelector('#paginate-current-offset').innerText;

                productsOnPage.insertAdjacentHTML(position, newProducts.innerHTML);
                window.history.pushState({}, '', url);
                if (position === 'beforeend') {
                    nextUrl = newProducts.dataset.nextUrl;
                } else {
                    prevUrl = newProducts.dataset.prevUrl;
                }

                document.querySelector('#load-pagination').innerHTML = nextPage
                    .querySelector('#load-pagination')
                    .innerHTML.replaceAll(newOffset, currentOffset);
            })
    }
});
